import { render, staticRenderFns } from "./numbered-items.vue?vue&type=template&id=f95a1f7a&"
import script from "./numbered-items.vue?vue&type=script&lang=js&"
export * from "./numbered-items.vue?vue&type=script&lang=js&"
import style0 from "./numbered-items.vue?vue&type=style&index=0&id=f95a1f7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports